var resm_module_cluster = (function (resm_module_cluster) {
  var clusterTemplate = $(
    '<a href="#" data-cluster-node="" class="gptw-node-cluster fixed-scale"><div><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.57 94.57"><defs><style>.clustercss-1{fill:#d40511;}.clustercss-2{opacity:.2;}.clustercss-3{opacity:.58;}.clustercss-4{opacity:.85;}.clustercss-5{opacity:0;}</style></defs><g class="clustercss-5"><circle class="clustercss-1" cx="47.28" cy="47.28" r="47.28"/></g><circle class="clustercss-1" cx="47.28" cy="47.28" r="20"/><g class="clustercss-3"><path class="clustercss-1" d="M47.28,13.48c-5.3,0-10.3,1.22-14.77,3.39l2.19,4.51c3.8-1.85,8.07-2.9,12.58-2.9,9.91,0,18.66,5.03,23.84,12.66l4.15-2.81c-6.08-8.96-16.35-14.85-27.99-14.85Z"/><path class="clustercss-1" d="M81,49.7l-4.99-.36c-1.01,14.24-12.42,25.65-26.66,26.66l.36,4.99c16.74-1.19,30.11-14.55,31.29-31.29Z"/><path class="clustercss-1" d="M28.33,75.28l2.81-4.15c-7.63-5.19-12.66-13.94-12.66-23.84,0-4.51,1.04-8.78,2.9-12.58l-4.51-2.19c-2.17,4.46-3.39,9.47-3.39,14.77,0,11.65,5.89,21.91,14.85,27.99Z"/></g><g class="clustercss-2"><path class="clustercss-1" d="M47.28,6.68c-6.36,0-12.38,1.46-17.74,4.07l2.17,4.47c4.71-2.29,9.99-3.58,15.57-3.58,12.26,0,23.09,6.22,29.51,15.67l4.11-2.79c-7.3-10.76-19.64-17.84-33.63-17.84Z"/><path class="clustercss-1" d="M87.78,50.19l-4.94-.35c-1.25,17.63-15.37,31.75-33,33l.35,4.94c20.11-1.42,36.16-17.48,37.59-37.59Z"/><path class="clustercss-1" d="M11.63,47.28c0-5.58,1.29-10.86,3.58-15.57l-4.47-2.17c-2.61,5.36-4.07,11.38-4.07,17.74,0,13.99,7.07,26.32,17.84,33.63l2.79-4.11c-9.45-6.42-15.67-17.25-15.67-29.51Z"/></g><g class="clustercss-4"><path class="clustercss-1" d="M47.28,20.41c-4.21,0-8.19,.97-11.74,2.69l2.19,4.5c2.89-1.41,6.13-2.2,9.55-2.2,7.52,0,14.16,3.82,18.1,9.61l4.15-2.81c-4.83-7.12-12.99-11.8-22.25-11.8Z"/><path class="clustercss-1" d="M74.08,49.21l-4.99-.36c-.77,10.81-9.43,19.47-20.24,20.24l.36,4.99c13.3-.94,23.93-11.57,24.87-24.87Z"/><path class="clustercss-1" d="M32.22,69.53l2.81-4.15c-5.8-3.94-9.61-10.58-9.61-18.1,0-3.42,.79-6.66,2.2-9.55l-4.5-2.19c-1.72,3.55-2.69,7.53-2.69,11.74,0,9.26,4.68,17.42,11.8,22.25Z"/></g></svg><span class="cluster-count"></span></div></a>'
  );

  var clusterTemplate = $(
    '<a href="#" data-cluster-node="" class="gptw-node-cluster fixed-scale"><div><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.38 69.38"><defs><style>.clustercss-1{opacity:.2;}.clustercss-1,.clustercss-2{fill:#d40511;}</style></defs><circle class="clustercss-1" cx="34.69" cy="34.69" r="34.69"/><circle class="clustercss-1" cx="34.69" cy="34.69" r="27.14"/><circle class="clustercss-1" cx="34.69" cy="34.69" r="23.55"/><circle class="clustercss-2" cx="34.69" cy="34.69" r="20"/></svg><span class="cluster-count"></span></div></a>'
  );

  var point_assignment_result;
  var cluster_centers;
  var dbscanner;
  var coordinates;

  resm_module_cluster.init = function () {
    // set up clustering algorithm
    // https://github.com/upphiminn/jDBSCAN
    dbscanner = jDBSCAN()
      // .eps(24.075) // higher = more caught in cluster radius, lower = 2x groups appear quicker too
      .eps(17) // higher = more caught in cluster radius, lower = 2x groups appear quicker too
      .minPts(1)
      .distance("EUCLIDEAN");

    // run the update cluster
    resm_module_cluster.updateClusters();
    // run on map change
    resm_module_panzoom.panzoom.on("update", function (e) {
      if (
        resm_module_utilities.isMobile ||
        resm_module_utilities.browser() == "safari"
      ) {
        debouncedUpdateClusters();
      } else {
        resm_module_cluster.updateClusters();
      }
    });

    // clusterupdate debounce function
    // for safari and mobile, this is used instead of the update every animationFrame due to performance.
    var debouncedUpdateClusters = resm_module_utilities.debounce(function () {
      resm_module_cluster.updateClusters();
    }, 30);

    // cluster clicks, go to region.
    $("#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom").on(
      "click",
      ".gptw-node-cluster",
      function (event) {
        event.preventDefault();
        var state = $("#gptw-wrapper").attr("data-view-state");
        var viewableCSNodes = [];
        $.each(
          $(
            "#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom .gptw-node:not(.hidden)"
          ),
          function (index, val) {
            var nodeId = $(this).attr("data-node-popup");
            viewableCSNodes.push({
              x: resmData[nodeId].x,
              y: resmData[nodeId].y,
            });
          }
        );
        // get nodes in the cluster and their coordingates to do a region fit.
        var clusterId = $(this).attr("data-cluster-id");
        // console.log(point_assignment_result);
        var nodesInCluster = [];
        point_assignment_result.forEach(function (point, index) {
          if (point === parseInt(clusterId)) {
            if (state == "customer-highlights") {
              nodesInCluster.push({
                x: cschmData[index].x,
                y: cschmData[index].y,
              });
            } else {
              nodesInCluster.push({
                x: viewableCSNodes[index].x,
                y: viewableCSNodes[index].y,
              });
            }
          }
        });

        // console.log('clusterId',clusterId);
        // console.log('point_assignment_result',point_assignment_result);
        // console.log('nodesInCluster',nodesInCluster);

        // try and fit but not too zoomed in method
        var rect = resm_module_utilities.rectFromXYPoints(nodesInCluster);
        var scaleTo = 2;

        if (rect.width > 200 || rect.height > 200) {
          scaleTo = 1;
          leftOffset = 50;
        }
        if (rect.width > 400 || rect.height > 400) {
          scaleTo = 0.4;
          leftOffset = 50;
        }
        // if only 2, dont go in too far
        if (
          nodesInCluster.length == 2 &&
          resm_module_panzoom.panzoom.scale < 0.7
        )
          scaleTo = 0.7;

        var cx = 0;
        var cy = 0;
        $.each(nodesInCluster, function (index, val) {
          cx += val.x;
          cy += val.y;
        });
        cx /= nodesInCluster.length;
        cy /= nodesInCluster.length;
        resm_module_panzoom.panzoom.smoothPanToPoint(cx, cy, scaleTo, 700);
      }
    );
  };

  resm_module_cluster.updateClusters = function () {
    // loop through active elements
    coordinates = [];
    $.each(
      $(
        "#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom .gptw-node:not(.hidden)"
      ),
      function (index, val) {
        var id = parseFloat($(this).attr("data-node-popup"));
        var x;
        var y;
        x = resmData[id].x;
        y = resmData[id].y;
        coordinates.push({
          id: id,
          x: x * resm_module_panzoom.panzoom.scale,
          y: y * resm_module_panzoom.panzoom.scale,
        });
      }
    );

    // give the data to the clustering class
    dbscanner.data(coordinates);
    point_assignment_result = dbscanner();
    cluster_centers = dbscanner.getClusters();

    $(
      "#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom .gptw-node-cluster"
    ).remove();
    cluster_centers.forEach(function (cluster_center, index) {
      var elementCount = countClusterElements(point_assignment_result, index);

      var node = clusterTemplate.clone();
      node.css({
        left: cluster_center.x / resm_module_panzoom.panzoom.scale + "px",
        top: cluster_center.y / resm_module_panzoom.panzoom.scale + "px",
      });
      node.find("span").html(elementCount);
      node.attr("data-cluster-id", index + 1);
      $("#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom").append(node);
    });

    // show / hide nodes
    $(
      "#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom .gptw-node"
    ).removeClass("clustered");
    point_assignment_result.forEach(function (point, index) {
      if (point != 0)
        $(
          '#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom .gptw-node[data-node-popup="' +
            coordinates[index].id +
            '"]'
        ).addClass("clustered");
    });

    // update the fixed scale routine list
    resm_module_panzoom.panzoom.updateFixedScaleChildren();
  };

  function countClusterElements(point_assignment_result, id) {
    var count = 0;
    for (var i = 0; i < point_assignment_result.length; i++) {
      if (point_assignment_result[i] == id + 1) count++;
    }
    return count;
  }

  function rectMultiple($elements) {
    var xs = Infinity;
    var ys = Infinity;
    var xl = 0;
    var yl = 0;
    $.each($elements, function (index, data) {
      var top = data.y;
      var left = data.x;
      if (left < xs) xs = left;
      if (top < ys) ys = top;
      if (left > xl) xl = left;
      if (top > yl) yl = top;
    });
    rect = { x: xs, y: ys, width: xl - xs, height: yl - ys };
    return rect;
  }

  return resm_module_cluster;
})(resm_module_cluster || {});
